<div class="row columns step-navigation" [class.event]="projectType == 'event'" [class.shop]="projectType == 'shop'" *ngIf="showNavigation()" (click)="stepBack()">
	<i class="twingle-arrow_left_solo"></i>
	<span [innerHtml]="(getTextPrefixTextkey() | translate: getPlaceholders()) + ' ' + getText()"></span>
</div>
